/* eslint-disable */

const PAY_BILLING_ORG = 'Pay billing organisation'
const VIEW_DELETE_PYMT = '/view-delete-payment'
const CHECK_TRANSACTION = '/check-transaction'
const MANAGE_ALERT = '/manage-alert'
const MANAGE_E_ALERTS = 'Manage e-Alerts'
const EPS = 'Electronic Payment for Shares (EPS)'
const MULTI_BILL_PYMT = 'Multiple bill payment'
const SINGLE_BILL_PYMT = 'Single bill payment'
const CHECK_INTERNET_TRANS_STATUS = 'Check internet transaction status'
const AUTH_HDHPLUS = ''

export const SYSTEM_MESSAGES_COMMON = {
	UNKNOWN_ERROR: {
		type: 'ERROR',
		msgId: 'unknown-error',
		defaultMsg: 'Unknown Error.'
	},
	API_ERROR: {
		type: 'ERROR',
		msgId: 'system-error',
		defaultMsg: 'System Error.'
	}
}

export const constants = {
	MY: {
		region: 'MY',
		favouriteBillSelectionOptions: [
			{
				value: 'BO',
				label: PAY_BILLING_ORG
			},
			{
				value: 'CC',
				label: 'Pay your HDH credit card bill'
			},
			{
				value: 'LN',
				label: 'Pay your HDH Loan/Financing'
			}
		],
		paymentSelectionOptions: [
			{
				value: 'ACC',
				label: 'Pay from your HDH Account'
			},
			{
				value: 'FPX',
				label: "Pay from your Other Bank's account in Malaysia"
			}
		],
		navItems: [
			{
				uri: '/jom-pay',
				name: 'Pay a JomPAY bill'
			},
			{
				uri: '/favourite-bill',
				name: 'Pay favourite bills'
			},
			{
				uri: '/manage-bill',
				name: 'Manage biller'
			},
			{
				uri: '/hdh-ge',
				name: 'Payments'
			},
			{
				uri: VIEW_DELETE_PYMT,
				name: 'View/Delete pending payments'
			},
			{
				uri: CHECK_TRANSACTION,
				name: 'Check transaction status'
			},
			{
				uri: MANAGE_ALERT,
				name: MANAGE_E_ALERTS
			}
		],
		contentTitle: {
			jomPay: 'Pay a JomPAY bill',
			favouriteBill: 'Pay favourite bills',
			manageBill: 'Manage biller',
			hdhGe: 'Payments',
			viewDeletePayment: 'View/Delete pending payments',
			checkTransaction: 'Check transaction status',
			manageAlert: MANAGE_E_ALERTS,
			sharePayment: EPS,
			otpDemo: 'OTP Demo'
		},
		afmsFunctionCode: {
			ownLoan: 'BillPymtCasaOwnLoan',
			billOrgPayment: 'FavouriteBillPaymentToOrg',
			singleBillOrgPayment: 'SingleBillPymt',
			addFTPayOtherBank: 'AddFTPayOtherBank',
			addBillOrgPayee: 'AddBillOrgPayee',
			ownCard: 'PayToOwnCC'
		},
		afmsPageIds: {
			ownLoan: '60311',
			billOrgPayment: '60311',
			singleBillOrgPayment: '60311',
			addFTPayOtherBank: '60501',
			addBillOrgPayee: '60501',
			ownCard: '60311'
		},
		reminderType: {
			PACPayee: 'PACPayee',
			Payee: 'Payee',
			OwnCC: 'OwnCC',
			AuthCC: 'AuthCC',
			OwnEC: 'OwnEC',
			OwnLN: 'OwnLN'
		},
		// this is for the payee org code to store in the DB,bacause OwnCC,AuthCC,OwnEC,OwnLN do not have  bill org code
		payeeOrgCode: {
			OwnCC: 'CC',
			AuthCC: 'AuthCC',
			OwnEC: 'EC',
			OwnLN: 'LN'
			// Payee and PacPayee will use the original code
		}
	},
	SG: {
		region: 'SG',
		multipleBillSelectionOptions: [
			{
				value: 'BO',
				label: PAY_BILLING_ORG
			},
			{
				value: 'CC',
				label: ''
			},
			{
				value: 'CA',
				label: 'Pay credit card bill from another bank (Visa / MasterCard)'
			}
		],
		navItems: [
			{
				uri: '/multiple-bill',
				name: MULTI_BILL_PYMT
			},
			{
				uri: '/single-bill',
				name: SINGLE_BILL_PYMT
			},
			{
				uri: '/manage-payees',
				name: 'Add & Manage payees'
			},
			{
				uri: VIEW_DELETE_PYMT,
				name: 'View or delete future-dated and recurring payment'
			},
			{
				uri: '/authorise-card-payer',
				name: 'Authorise card payer'
			},
			{
				uri: '/manager-card-payer',
				name: 'Manage authorised card payer'
			},
			{
				uri: CHECK_TRANSACTION,
				name: CHECK_INTERNET_TRANS_STATUS
			},
			{
				uri: MANAGE_ALERT,
				name: MANAGE_E_ALERTS
			},
			{
				uri: '/share-payment',
				name: 'Share Payment(EPS)'
			},
			{
				uri: '/transaction-history',
				name: 'Transaction history/status'
			}
		],
		contentTitle: {
			multipleBill: MULTI_BILL_PYMT,
			singleBill: SINGLE_BILL_PYMT,
			managePayees: 'Add & Manage Billing Organisations',
			viewDeletePayment: 'Manage future-dated and recurring payment',
			// authoriseCardPayer: AUTH_HDHPLUS,
			authoriseCardPayerAcknowledgement: AUTH_HDHPLUS,
			manageCardPayer: 'Remove Credit Card Payer',
			checkTransaction: CHECK_INTERNET_TRANS_STATUS,
			manageAlert: MANAGE_E_ALERTS,
			PayOneOffBills: 'Pay One-off Bills',
			PayGularBills: 'Pay Regular Bills',
			sharePayment: EPS,
			otpDemo: 'OTP Demo'
		},
		afmsFunctionCode: {
			billOrgPayment: 'FavouriteBillPaymentToOrg',
			singleBillOrgPayment: 'SingleBillPymt',
			addBillOrgPayee: 'AddBillOrgPayee',
			pymtAnyCrd: 'PymtAnyCrd',
			addOtherBankCardPayee: 'AddPayAnyCrd',
			ownCard: 'PayToOwnCC',
			authCard: 'BP_TO_AUTH_CC_PAYEE'
		},
		afmsPageIds: {
			billOrgPayment: '60311',
			singleBillOrgPayment: '60311',
			addBillOrgPayee: '65501',
			pymtAnyCrd: '65311',
			addOtherBankCardPayee: '65501',
			ownCard: '60311',
			authCard: '60311'
		},
		reminderType: {
			PACPayee: 'PACPayee', // pac
			Payee: 'Payee', // bill org
			OwnCC: 'OwnCC', // MY Own Credit Cards/Own Card
			AuthCC: 'AuthCC', // SG- pay someone else's/Authorised card
			OwnEC: 'OwnEC', // OwnEasicCredit
			OwnLN: 'OwnLN' // MY-Own Loan Own Loan Accounts
		},
		// this is for the payee org code to store in the DB,bacause OwnCC,AuthCC,OwnEC,OwnLN do not have  bill org code
		payeeOrgCode: {
			OwnCC: 'CC',
			AuthCC: 'AuthCC',
			OwnEC: 'EC',
			OwnLN: 'LN'
			// Payee and PacPayee will use the original code
		}
	},
	common: {
		isDev: 'DEV',
		isJomPay: 'NBPS',
		toggleState: {
			on: 'on',
			off: 'off'
		},
		selectDefaultParam: 'placeholder',
		userInputParam: {
			userInput: 'UI',
			userSelection: 'US'
		},
		paymentModeCategories: {
			CASA_CC: 'CASA_CC',
			CASA: 'CASA',
			CC: 'CC'
		},
		responseStatusCategories: {
			SUCCESS: 'SUCCESS',
			FAILED: 'FAILED',
			PARTIAL: 'PARTIAL',
			UNKNOWN: 'UNKNOWN',
			TAC_REQUIRED: 'TAC_REQUIRED'
		},
		paymentInstructionType: {
			FUTURE: 'FUTURE',
			IMMEDIATE: 'IMMEDIATE'
		},
		tncStatusCategories: {
			TNC_REQUIRED: 'TNC_REQUIRED',
			TNC_PASSED: 'TNC_PASSED'
		},
		defaultRecurringOption: {
			recurringOption: 'No',
			recurringMode: 'placeholder',
			recurringStartDate: new Date(new Date().getTime() + 86400000),
			recurringCount: '2',
			recurringEndDate: null
		},
		jomPayDefaultBillResult: {
			billerCode: '',
			refOne: '',
			refTwo: ''
		},
		jomPayDefaultAmountResult: {
			amount: '',
			amountError: 'off',
			paymentDate: new Date(),
			payee: 'placeholder',
			accountList: []
		},
		hdhGeDefaultBillResult: {
			billerOrgId: 'placeholder',
			selectedBillerOrg: {},
			billerOrgList: [],
			billerOrgListDropDown: []
		},
		hdhGeDefaultAmountResult: {
			amount: '',
			amountError: 'off',
			paymentDate: new Date(),
			payee: 'placeholder',
			accountList: []
		},
		singleBillDefaultBillResult: {
			billerOrgId: 'placeholder',
			selectedBillerOrg: {},
			billerOrgList: [],
			billerOrgListDropDown: []
		},
		singleBillDefaultAmountResult: {
			amount: '',
			amountError: 'off',
			paymentDate: new Date(),
			payee: 'placeholder',
			accountList: []
		},
		errorActorCategories: {
			amount: 'amount',
			billOrgCode: 'billOrgCode',
			billRefNo0: 'billRefno_0',
			billRefNo1: 'billRefno_1',
			billRefNo: 'billRefno_',
			paymentDate: 'paymentDate',
			recurringInfo: 'recurringInfo',
			recurringMode: 'recurringMode',
			recurringStartDate: 'recurringStartDate',
			recurringEndDate: 'recurringEndDate',
			recurringCount: 'recurringCount',
			billOrgId: 'billOrgId',
			nickname: 'nickname'
		},
		futureTransactionType: {
			billOrganization: 'bill-organization',
			otherBankCard: 'other-bank-card',
			ownLoan: 'own-loan',
			ownCard: 'own-card'
		},
		transactionStatus: {
			Pending: 'PENDING',
			Progress: 'PROGRESS',
			Deleted: 'DELETED',
			Inactive: 'INACTIVE',
			Accepted: 'ACCEPTED',
			Successful: 'SUCCESSFUL',
			Unsuccessful: 'UNSUCCESSFUL',
			Cancelling: 'CANCELLING'
		},
		otpDefaultParams: {
			otpHidden: true, //  Control the Otp Screen Show or Hide
			transactionId: '', //  Transaction ID that need to carry from */submit api
			authorizationId: '', //  Authorization ID that need to carry from */submit api
			authorizationTypeCode: 'SMS_OTP', //  Authorization Type Code that need to carry from */submit api
			authorizationReference: '', // prefix from SMS/ Hardware config, currently is optional
			otp: '', //  OTP value for OTP popup
			triggerOTP: 'NO', //  decide whether need trigger otp at web client
			challengeCode: '', //  whether swk push notification ui manually switch to swk otp ways
			maskedMobileNo: 'XXXX XXXX' //  sms_otp need client mask mobile number
		},
		addOrgBillerLayoutType: {
			withOrgDropdownList: 'WITH_ORG_DROPDOWN_LIST',
			withoutOrgDropdownList: 'WITHOUT_ORG_DROPDOWN_LIST'
		},
		loanPaymentOptionList: {
			installmentRepayment: 'INSTALLMENT_REPAYMENT',
			capitalRepayment: 'CAPITAL_REPAYMENT',
			lateCharges: 'LATE_CHARGES',
			miscCharges: 'MISC_CHARGES',
			otherCharges: 'OTHER_CHARGES'
		},
		fpxBankStatusList: {
			ACTIVE: 'ACTIVE',
			BLOCK: 'BLOCK'
		},
		authoriseCardPayer: {
			ACCEPTED: 'ACCEPTED'
		},
		errorDescription: {
			generalError: 'System temporary unavailable'
		},
		creditCardPage: {
			ownCC: 'own credit card',
			authCC: 'authorize credit card'
		}
	}
}
